import type { Resolver } from 'cpool-schemas';
import { z } from 'zod';

import { schemaOffersEuropace } from '../tables';

type Arguments = {
    id: string;
    position?: number;
    requestId: string;
};
export const schemaLoanRequestResolver_GetOffersByRequestId = z.array(schemaOffersEuropace).nullable();

export type SchemaLoanRequestResolver_GetOffersByRequestId = z.infer<
    typeof schemaLoanRequestResolver_GetOffersByRequestId
>;

export type LoanRequestResolver_GetOffersByRequestId = Resolver<
    Arguments,
    SchemaLoanRequestResolver_GetOffersByRequestId
>;
